/*
 * File: SearchResults.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 10/17/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Renders a list of results from a referral name search
 */
import React from "react";
import PropTypes from "prop-types";
import UILinkList from "components/ui/UILinkList";

const SearchResults = ({ referrals }) => {
  const links = referrals.map(referral => {
    const nameString = referral.first + " " + referral.last;
    return {
      primaryString: nameString,
      url: referral.linkTo,
      secondaryString: referral.company
    };
  });

  return <UILinkList links={links} includeArrow={false} />;
};

SearchResults.propTypes = {
  referrals: PropTypes.array
};

export default SearchResults;
